/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DropsInputs */

const en_drops = /** @type {(inputs: DropsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drops`)
};

const de_drops = /** @type {(inputs: DropsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drops`)
};

/**
* | output |
* | --- |
* | "Drops" |
*
* @param {DropsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const drops = /** @type {((inputs?: DropsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DropsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drops(inputs)
	return de_drops(inputs)
});